import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Forces the page to scroll to the top of the hero whenever the URL pathname
 * changes. Without this, react-router preserves the previous scroll position
 * on navigation — so clicking a top-nav link from mid-page lands the user
 * partway down the new page instead of at its hero.
 *
 * Respects in-page anchors (e.g. /trainings/aerial-yoga#upcoming) so jump
 * links still work.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the browser handle in-page anchors
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
